import styled from "styled-components";


export const InfoContainer = styled.div`

	background: #FFFFFF 0% 0% no-repeat padding-box;
  opacity: 0.8;

	@media screen and (max-width: 768px) {
		padding: 0 0;
	}

`;

export const InfoWrapper = styled.div`
	display: grid;
	z-index: 1;
	height: 600px;
	width: 100%;
	max-width: 1100px;
	margin-right: auto;
	margin-left: auto;
	justify-content: center;
  @media screen and (max-width: 880px) {
		height: 950px;
	}
  @media screen and (max-width: 480px) {
		height: 950px;
    padding-top: 70px;
    margin-bottom: 30px;
	}
`;

export const InfoRow = styled.div`
	display: grid;
	grid-auto-columns: minmax(auto, 1fr);
	grid-template-areas:  'col1 col2 col3';

	@media screen and (max-width: 880px) {
		grid-template-areas:  'col1' 'col2' 'col3';

	}
`;

export const Column1 = styled.div`
	margin-bottom: 15px;
  width: 100%;
	padding: 0 15px;
	grid-area: col1;
  margin-right: 40px;
  margin-top: 70px;
  @media screen and (max-width: 1250px){
		width: 250px;
	}
  
  @media screen and (max-width: 880px) {
    margin-top: 10px;
    padding: 0;
	}
`;

export const Column2 = styled.div`
	margin-bottom: 15px;
  margin-top: 100px;
	padding: 0 15px;
  width: 100%;
  margin-right: 40px;

	grid-area: col2;
  @media screen and (max-width: 1250px){
		width: 250px;
		
	}
  @media screen and (max-width: 880px) {
		margin-top: 0px;
    margin-bottom: 0;
  	padding: 0 0;
	}
`;
export const Column3 = styled.div`
	margin-bottom: 15px;
  margin-top: 100px;
	padding: 0 15px;
	grid-area: col3;
  width: 100%;
  @media screen and (max-width: 1250px){
		width: 250px;
	}

  @media screen and (max-width: 880px) {
		margin-top: 0px;
    margin-bottom: 0;
    padding: 0;
	}
`;
export const TextWrapper = styled.div`
	max-width: 540px;
	padding-top: 0;
	padding-top: 100px;
  @media screen and (max-width: 880px){
		padding-top: 20px;
	}
`;

export const TopLine = styled.p`
	color: #383838;
  max-width: 310px;
	line-height: 16px;
  font: normal normal normal 15px "Spoqa Han Sans Neo";
	text-transform: unset;
	margin-bottom: 16px;
  text-align: left;
  letter-spacing: -0.83px;
  @media screen and (max-width: 1250px) {
		max-width: 100%;
    height: auto;
		font-size: 15px;
	}
  @media screen and (max-width: 480px){
		font-size: 14px;
	}
`;

export const Icon = styled.h1`
	margin-bottom: 24px;
	font: normal normal bold 28px "Spoqa Han Sans Neo";
	line-height: 1.1;
  width: 318px;
  color: #4D565E;
	@media screen and (max-width: 480px){
		font-size: 28px;
	}
`;
export const Heading = styled.h1`
	font: normal normal bold 30px "Spoqa Han Sans Neo";
	line-height: 0.8;
  width: 318px;
  color: #2783C6;
	@media screen and (max-width: 480px){
		font-size: 28px;
	}
`;

export const Subtitle = styled.p`
	max-width: 440px;
	font-size: 18px;
	line-height: 24px;
  color: #000000;
  @media screen and (max-width: 480px){
		font-size: 14px;
	}
`;

export const Boldtitle = styled.p`
	max-width: 440px;
	margin-bottom: 25px;
  text-align: left;
	font: normal normal bold 21px "Spoqa Han Sans Neo";
	line-height: 24px;
  color: #383838;
  @media screen and (max-width: 480px){
		font-size: 18px;
	}
`;


export const ImgWrap =styled.div`
	max-width: 100%;
	height: auto;
  width: 310px;
  margin-bottom: 10px;
`;

export const Img = styled.img`
	width: 310px;
  height: 200px;
  background-color: black;
  border-radius: 5px;
  @media screen and (max-width: 1250px) {
		max-width: 280px;
    height: 180px;
	}

  :hover{
    -moz-box-shadow: 0 0 10px #ccc;
    -webkit-box-shadow: 0 0 10px #ccc;
    box-shadow: 0 0 15px #000000;
  }

`;